import { ILabel, ILabelCreate, ILabelUpdate } from '../../resource/label/label.types';
import { IApiRequestConfig } from '../api.types';

export const searchLabelsApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getLabels',
  action: 'labels',
  method: 'get',
  v2: true,
});

export const createLabelApi = (label: ILabelCreate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createLabel',
  action: `meetings/${label.meetingId}/labels`,
  method: 'post',
  data: { name: label.name, color: label.color },
  v2: true,
});

export const updateLabelApi = (label: ILabelUpdate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateLabel',
  action: `labels/${label.id}`,
  method: 'put',
  data: label,
  v2: true,
});

export const deleteLabelApi = (labelId: ILabel['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteLabel',
  action: `labels/${labelId}`,
  method: 'delete',
  v2: true,
});
